module.exports = "/_next/static/images/d6653117e5fb2beca23f1904b12236b7-walmart-icon.svg";